import {
	Box,
	Card,
	Grid,
	IconButton,
	Stack,
	TextField,
	Typography,
} from '@mui/material';

import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import { ReactComponent as MessagePlane } from 'common/assets/images/MessagePlane.svg';
import { RootState } from 'common/store/AppStore';
import {
	dateInCorrectFormatWithFullYearTime,
	startsWithDigitDate,
} from 'common/utils/utilFunctions';

import { IObligationComments, IExertCommentsProps } from '../api/type-def';

import styles from './ExertComments.module.scss';

const ExertComments = (props: IExertCommentsProps) => {
	const { handleClickClose, Id, saveParagraphComment, pageNumber } = props;

	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const [obligationToPolicyComment, setObligationToPolicyComment] =
		useState('');

	const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setObligationToPolicyComment(event.target.value);
	};

	const obligationToPolicyCommentList = useSelector(
		(state: RootState) => state.common.obligationToPolicyCommentList,
	);

	const filteredComments = obligationToPolicyCommentList.filter(
		(item: IObligationComments) => item.paragraphId === Id,
	);

	const handlePostComment = () => {
		if (obligationToPolicyComment.trim() !== '') {
			saveParagraphComment(obligationToPolicyComment, Id);
			setObligationToPolicyComment('');
		}
	};

	return (
		<Box
			className={styles['detailed-container']}
			role="presentation"
			data-testid="groups-container"
		>
			<div className={styles['sources-top-div']}>
				<div
					className={styles['groups-text-background']}
					data-testid="comments-top-div"
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						spacing={2}
						data-testid="close-button-stack"
					>
						<Typography className={styles['source-heading']}>
							Citation-Page {pageNumber}
						</Typography>
						<IconButton
							size="large"
							onClick={handleClickClose}
							data-testid="close-groups-btn"
							className={styles['close-icon']}
						>
							<DrawerClose fill={styles.drawerCloseIconColor} />
						</IconButton>
					</Stack>
				</div>
			</div>
			<div className={styles['comment-main']}>
				<div className={styles['comment-height']}>
					{filteredComments.map((item: IObligationComments) => (
						<Card
							key={item.id}
							className={
								item.email === loggedInUser?.email || !item.email
									? styles['comment-card']
									: styles['comment-card-user']
							}
						>
							{item.comment}
							<div>
								<Typography>{item.fullName}</Typography>
								<Typography>
									{dateInCorrectFormatWithFullYearTime(
										`${item.createdDate || ''}${
											item.createdDate && startsWithDigitDate(item.createdDate)
												? 'Z'
												: ''
										}`,
									).replace(',', '')}
								</Typography>
							</div>
						</Card>
					))}
				</div>
				<Grid className={styles['comment-text']} gap={2}>
					<Grid item xs={11} lg={11} md={11} sm={11}>
						<TextField
							fullWidth
							value={obligationToPolicyComment}
							onChange={handleCommentChange}
							inputProps={{ 'data-testid': 'comment-textFeild' }}
						/>
					</Grid>
					<Grid item xs={1} lg={1} md={1} sm={1}>
						<IconButton
							disableRipple
							data-testid="comment-post-btn"
							onClick={handlePostComment}
						>
							<div className={styles.btn}>
								<Box>
									<MessagePlane fill={styles.whiteTextColor} />
								</Box>
							</div>
						</IconButton>
					</Grid>
				</Grid>
			</div>
		</Box>
	);
};

export default ExertComments;
